import React, { useImperativeHandle, forwardRef } from "react";
import { Button, Col, Row, Form, Space, Card } from "antd";
import { SearchOutlined, EditOutlined } from '@ant-design/icons';

const InventoryForm = forwardRef(({
  title,
  form,
  isLoading,
  handleSubmit,
  disabled,
  submit,
  reset,
  children,
  customAction,
  validate,
  initialValues,
  customActionJustify,
  hideActions,
  layout,
  extra,
  getFormValues,
  setIsFormValuesChange
}, ref) => {
  
  const handleFormData = (values) => {
    handleSubmit(values);
    if (getFormValues) {
      getFormValues(values); // Pass values to parent
      setIsFormValuesChange(true);
    }
  };

  useImperativeHandle(ref, () => ({
    submit: () => form.submit(), // Expose form submission method
  }));

  return (
    <Card title={title} bordered={false} extra={extra}>
      <Form
        form={form}
        onFinish={(values) => handleFormData(values)}
        layout={layout || "vertical"}
        autoComplete="off"
        onValuesChange={(change, values) => {
          handleFormData(values)
          if (validate) {
            validate(change, values);
          }
        }}
        initialValues={initialValues}
      >
        {children}
        {!hideActions && (
          <Row gutter={[10, 0]} className={`justify-end mt-2`}>
            <Space>
              {customAction && customAction}
              {reset !== false && (
                <Col>
                  <Button disabled={disabled} htmlType="reset" danger>
                    {reset || "Reset"}
                  </Button>
                </Col>
              )}
            </Space>
          </Row>
        )}
      </Form>
    </Card>
  );
});

export default InventoryForm;
